export const Courses = [
    { name: 'OnCourse', code: 'oncourse' }
];